import { Expose } from "class-transformer";
import type { IProfileData } from "./profile-data.entity.interface";

export class ProfileData implements IProfileData {
  @Expose()
  lastUpdatedDate?: string;

  @Expose()
  isHouseholdCompositionAsked?: boolean;

  @Expose()
  isHouseholdConfirmed?: boolean;

  @Expose()
  hasKnownIsee?: boolean;

  @Expose()
  hasDeclaredIncome?: boolean;

  @Expose()
  isIncomeConfirmed?: boolean;

  @Expose()
  isRealEstateConfirmed?: boolean;
}
